module.exports = __webpack_public_path__ + "img/lego-bg-xl.68a64411.jpg";